import { trpc } from "../trpc";
import { useUserAccountRole } from "../permissions/useUserAccountRole";

const PAUSED_ZAPS_CACHE_MS = 1000 * 60 * 10;

interface useQueryPausedZapsInput {
  enabled?: boolean;
}

export function useQueryPausedZaps({
  enabled = true,
}: useQueryPausedZapsInput) {
  const { customuserId, isSuperAdmin, isAdmin } = useUserAccountRole();

  const zapsResponse = trpc.zap.pausedZaps.useQuery(
    {
      isAdmin: isAdmin || isSuperAdmin,
      customuserId,
    },
    // /api/v4/zaps returns every Zap the caller can access (all of a large
    // account for admins), which is slow; batched, it holds up the others.
    // Paused-by-plan state only changes with the plan, so cache it longer.
    {
      enabled,
      staleTime: PAUSED_ZAPS_CACHE_MS,
      gcTime: PAUSED_ZAPS_CACHE_MS,
      trpc: { context: { skipBatching: true } },
    },
  );

  return {
    isFetching: zapsResponse.isFetching,
    isLoading: zapsResponse.isLoading,
    response: zapsResponse.data,
  };
}
